import {AssetsRequestParams} from "../../../infrastructure/models/params/assets-request-params";
import {IMAGE_DEFAULT_FORMATS} from "../../../core/app/consts";

export class GameStatsWidgetInfoIconRequestParams extends AssetsRequestParams {
  constructor(width: Number, height: Number, color: String) {
    super(width, height);

    this.resourceName = this.resourceName + `/Info`
    this.color = color;
    this.ratio = 2;
  }

  get defaultFormat(): String {
    return IMAGE_DEFAULT_FORMATS.SVG;
  }
}